import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useScrollAnimation } from './useScrollAnimation';
const testimonials = [{
  initials: 'JL',
  name: 'Juan Lucero',
  quote: "Andy did an amazing job getting my garage and driveway back to clean concrete! Previous tenants had left a mess with tire marks and oil stains all over the place, now it's back to new."
}, {
  initials: 'JT',
  name: 'Joe Templin',
  quote: "This guy killed it on our patio at Joe's Barber Shop here in Maricopa. We had major damage from the last guys. Thanks Andy!"
}, {
  initials: 'KR',
  name: 'Kendria',
  quote: 'Just had them come out and pressure wash the garage, driveway and front porch. They did an excellent job and I would absolutely hire them again.'
}, {
  initials: 'MC',
  name: 'Monica Cardenas',
  quote: 'Excellent, reliable and reasonable price. These guys get the job done. Highly recommend their services. Andy is a professional at what he does.'
}, {
  initials: 'AA',
  name: 'Anthony Armas',
  quote: 'This guy is the man, much respect to him. He actually shows up when he says he does and communicates when needed.'
}];
export function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const ref = useScrollAnimation();
  return <section id="reviews" className="w-full py-20 px-4" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-217">
      <div className="max-w-7xl mx-auto" ref={ref} data-id="element-218">
        {/* Heading */}
        <div className="text-center mb-12 scroll-animate" data-id="element-219">
          <h2 className="font-bold mb-3" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(26px, 4vw, 40px)',
          color: '#0283C7',
          fontWeight: 800
        }} data-id="element-220">
            What Our Customers Are Saying
          </h2>
          <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className="font-semibold transition-opacity hover:opacity-70" style={{
          color: '#0283C7',
          fontFamily: 'Inter, sans-serif',
          fontSize: '15px'
        }} data-id="element-221">
            See All Reviews →
          </a>
        </div>

        {/* Desktop: all cards */}
        <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-222">
          {testimonials.map((t, i) => <div key={i} className="scroll-animate bg-white p-6 flex flex-col gap-4 rounded-2xl border-l-4" style={{
          borderLeftColor: '#0283C7',
          boxShadow: '0 4px 20px rgba(2,131,199,0.08)',
          transitionDelay: `${i * 0.1}s`
        }} data-id="element-223">
              <div className="flex items-center gap-3" data-id="element-224">
                <div className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-white text-sm flex-shrink-0" style={{
              backgroundColor: '#0283C7',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-225">
                  {t.initials}
                </div>
                <div data-id="element-226">
                  <p className="font-bold" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px'
              }} data-id="element-227">
                    {t.name}
                  </p>
                  <div className="flex gap-0.5 mt-0.5" data-id="element-228">
                    {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-current" style={{
                  color: '#F59E0B'
                }} data-id="element-229" />)}
                  </div>
                </div>
              </div>
              <p style={{
            color: '#374151',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            lineHeight: 1.65
          }} data-id="element-230">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Mobile: carousel */}
        <div className="md:hidden" data-id="element-231">
          <div className="bg-white p-6 flex flex-col gap-4 rounded-2xl border-l-4" style={{
          borderLeftColor: '#0283C7',
          boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
        }} data-id="element-232">
            <div className="flex items-center gap-3" data-id="element-233">
              <div className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-white text-sm flex-shrink-0" style={{
              backgroundColor: '#0283C7',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-234">
                {testimonials[active].initials}
              </div>
              <div data-id="element-235">
                <p className="font-bold" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px'
              }} data-id="element-236">
                  {testimonials[active].name}
                </p>
                <div className="flex gap-0.5 mt-0.5" data-id="element-237">
                  {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-current" style={{
                  color: '#F59E0B'
                }} data-id="element-238" />)}
                </div>
              </div>
            </div>
            <p style={{
            color: '#374151',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            lineHeight: 1.65
          }} data-id="element-239">
              "{testimonials[active].quote}"
            </p>
          </div>
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-240">
            <button onClick={() => setActive(a => a === 0 ? testimonials.length - 1 : a - 1)} className="w-10 h-10 rounded-full border-2 flex items-center justify-center transition-colors hover:bg-blue-50" style={{
            borderColor: '#0283C7'
          }} aria-label="Previous" data-id="element-241">
              <ChevronLeftIcon className="h-5 w-5" style={{
              color: '#0283C7'
            }} data-id="element-242" />
            </button>
            <div className="flex gap-2" data-id="element-243">
              {testimonials.map((_, i) => <button key={i} onClick={() => setActive(i)} className="w-2.5 h-2.5 rounded-full transition-colors" style={{
              backgroundColor: i === active ? '#0283C7' : '#CBD5E1'
            }} aria-label={`Go to ${i + 1}`} data-id="element-244" />)}
            </div>
            <button onClick={() => setActive(a => a === testimonials.length - 1 ? 0 : a + 1)} className="w-10 h-10 rounded-full border-2 flex items-center justify-center transition-colors hover:bg-blue-50" style={{
            borderColor: '#0283C7'
          }} aria-label="Next" data-id="element-245">
              <ChevronRightIcon className="h-5 w-5" style={{
              color: '#0283C7'
            }} data-id="element-246" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}